import axios from "axios";
import toast from "react-hot-toast";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewCollectionsList = (collectionData) => {
  return async (dispatch) => {
    if (!collectionData.collection_id) {
      dispatch({ type: "START_LOADING" });
      try {
        dispatch({ type: "GET_COLLECTIONS_LIST_REQUEST" });
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        const { data } = await axios.post(
          `${BASE_URL}/collection/list`,
          collectionData,
          config
        );

        if (data.statusCode === 200) {
          dispatch({ type: "GET_COLLECTIONS_LIST_SUCCESS", payload: data });
          return data;
        } else {
          dispatch({ type: "GET_COLLECTIONS_LIST_FAILED", payload: data });
          return data;
        }
      } catch (error) {
        dispatch({
          type: "GET_COLLECTIONS_LIST_FAILED",
          payload: error?.response?.data,
        });
        return error?.response?.data;
      } finally {
        dispatch({ type: "STOP_LOADING" });
      }
    }
    if (collectionData.collection_id) {
      dispatch({ type: "START_LOADING" });
      try {
        dispatch({ type: "GET_SUB_COLLECTIONS_LIST_REQUEST" });
        const config = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        const { data } = await axios.post(
          `${BASE_URL}/collection/list`,
          collectionData,
          config
        );

        if (data.statusCode === 200) {
          dispatch({ type: "GET_SUB_COLLECTIONS_LIST_SUCCESS", payload: data });
        } else {
          dispatch({ type: "GET_SUB_COLLECTIONS_LIST_FAILED", payload: data });
        }
      } catch (error) {
        dispatch({
          type: "GET_SUB_COLLECTIONS_LIST_FAILED",
          payload: error?.response?.data?.message,
        });
      } finally {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const addNewCollections = (collectionData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_COLLECTION_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/collection/add`,
        collectionData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_COLLECTION_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_COLLECTIONS_FAILED", payload: data });
        toast.error("Failed to Add");
      }
    } catch (error) {
      dispatch({
        type: "ADD_COLLECTIONS_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Failed to Add");
    }
  };
};

export const addSubCollections = (subCollectionData) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "ADD_SUB_COLLECTION_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/collection/add`,
        subCollectionData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "ADD_SUB_COLLECTION_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        return data;
      } else {
        dispatch({ type: "ADD_SUB_COLLECTION_FAILED", payload: data });
        toast.error("Failed to Add!");
      }
    } catch (error) {
      dispatch({
        type: "ADD_SUB_COLLECTION_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error("Failed to Add!");
    }
  };
};

export const editCollection = (collectionData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_COLLECTION_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/collection/update`,
        collectionData,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_COLLECTION_SUCCESS", payload: data });
        toast.success("Edited Successfully!");
        return data;
      } else {
        dispatch({ type: "EDIT_COLLECTION_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "EDIT_COLLECTION_FAILED",
        payload: error?.response?.data?.message,
      });
      toast.error(error?.response?.data?.message);
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewOneCollection = (collectionData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_COLLECTION_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/collection/${collectionData}`,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_COLLECTION_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_COLLECTION_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_COLLECTION_FAILED",
        payload: error?.data?.response?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
